import { _deepClone } from '../../../helpers/utilities';
import { writable } from 'svelte/store';

export interface IAlarmZone {
	id?: string | number; //on scene list for dnd module
	_id?: string | number; //on scene edit
	_enabled?: boolean | string;
	_gui_function?: string;
	_run_on_ingest?: boolean; //,boolean;
	_enable_delay?: number;
	pin_lock?: boolean;
	_meta?: {
		name: string;
		image: string;
		position?: number;
		room: number | string;
		roomn?: string;
		sensors?: string;
		active?: number;
		triggered?: boolean;
		backgroundColor?: string;
		enable_delay_units: 'sec' | 'min';
		_time_trigger?: number | null;
	};
	if?: {
		or?: any[];
		and?: any[];
	};
	do?: any[];
	new?: boolean;
}

// const create_alarm_object = () => {
// 	let scene: IAlarmZone = {
// 		_enabled: true,
// 		_run_on_ingest: false, //always false
// 		_gui_function: 'alarm',
// 		_meta: {
// 			name: '',
// 			image: '',
// 			room: -1,
// 			roomn: ''
// 		},
// 		if: {
// 			or: []
// 		},
// 		do: [
// 			{
// 				notify: 'both',
// 				msg: '',
// 				msg_type: 'alarm'
// 			},
// 			{ notifyUI: { type: 'alarm', triggered: true } }
// 		]
// 	};
// 	const { subscribe, set, update } = writable(scene);

// 	return {
// 		subscribe,
// 		change: (newScene: IAlarmZone) => {
// 			update((props: IAlarmZone) => {
// 				props = _deepClone(newScene) as IAlarmZone;
// 				return props;
// 			});
// 		},
// 		reset: () => set(scene)
// 	};
// };

// export const alarm_object_prototype = create_alarm_object();
export const ALARM_TIME_TRIGGER_DEFAULT = null;

export const alarm_object_prototype: IAlarmZone = {
	_enabled: true,
	_run_on_ingest: false, //always false
	_gui_function: 'alarm',
	_meta: {
		name: '',
		image: '',
		room: -1,
		roomn: '',
		position: -2,
		enable_delay_units: 'sec',
		_time_trigger: ALARM_TIME_TRIGGER_DEFAULT,
	},
	if: {
		or: [],
	},
	do: [
		{
			wait: '0', // this daley triggers the 'do' block. Old alarms did not have this feature. They have only the external "do" with two objects. If we remove the 'do' and the 'blk' inside it in the first object the 'wait' property, the delay, will not work.
			units: 'sec',
			do: {
				blk: [
					{
						notify: 'both',
						_gui_function: 'alarm',
						msg: 'My scene triggered!',
						msg_type: 'alarm',
					},
					{ notifyUI: { type: 'alarm', triggered: true } },
				],
			},
		},
	],
	_enable_delay: 0,
};
